import { useList, useMany } from '@refinedev/core';

interface MitreMitigation {
  id: string;
  mitigation_id: string;
  technique_id: string;
  name: string;
  mitre_attack_version: string;
  description: string;
}

interface ScenarioMitreMitigation {
  id: string;
  scenario: string;
  mitre_mitigation: string;
}

interface UseMitreMitigationsResult {
  data: MitreMitigation[];
  isLoading: boolean;
  error: Error | null;
}

export const useMitreMitigations = (scenarioId?: string): UseMitreMitigationsResult => {
  const shouldFetch = Boolean(scenarioId);

  const {
    result: data,
    query: { isLoading, error }
  } = useList<ScenarioMitreMitigation>({
    resource: 'scenario_mitre_mitigations',
    filters: shouldFetch
      ? [
          {
            field: 'scenario',
            operator: 'eq',
            value: scenarioId
          }
        ]
      : [],
    queryOptions: {
      enabled: shouldFetch,
      queryKey: ['scenario_mitre_mitigations', scenarioId]
    }
  });

  const mitigationIds = data?.data?.map(m => m.mitre_mitigation) ?? [];

  const {
    result: mitigationsData,

    query: { isLoading: mitigationsLoading, error: mitigationsError }
  } = useMany<MitreMitigation>({
    resource: 'mitre_mitigations',
    ids: mitigationIds,
    queryOptions: {
      enabled: shouldFetch && mitigationIds.length > 0,
      queryKey: ['mitre_mitigations', mitigationIds]
    }
  });

  return {
    data: mitigationsData?.data ?? [],
    isLoading: isLoading || (shouldFetch && mitigationIds.length > 0 ? mitigationsLoading : false),
    error:
      (error ? (error as unknown as Error) : null) ||
      (mitigationsError ? (mitigationsError as unknown as Error) : null) ||
      null
  };
};
